export default async function UpdateProject(sendForm) {
    let url = window.RealestateService+  `/api/Project/UpdateProject`
    let head = {
        "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"POST",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}